// extracted by mini-css-extract-plugin
export default {"wrapper":"EmailLabel_wrapper"};